import React, { useEffect, useState } from "react";

import Header from "../components/Header-2";
import ImgMasonry from "../components/Masonry";

const images = [
  "/landscapes/still_life.jpg",
  "/landscapes/Lucia_DSC4543-1_nQjuuaZu_.jpg?updatedAt=1722897593162",
  "/landscapes/sCanouan2_DSC4809_PGV5ELhsU.jpg?updatedAt=1722897592195",
  "/landscapes/IMG_0192_Zkwsb_iPa.JPG?updatedAt=1722897535246",
  "/landscapes/_DSC0845_IfkuQYB6b.webp",
  "/landscapes/_DSC4471_r-tYx5-E9.webp",
  "/landscapes/DSC_2014_qKnJq1eyr.webp",
  "/landscapes/_DSC0877_XGwRR21lw.webp",
  "/landscapes/_DSC5807-2_qSdJUqKpI.jpg",
  "/landscapes/Canouan_DSC4684_OjllzHKrK.webp",
  "/landscapes/IMG_0288_vwhYtYH18.JPG?updatedAt=1722897541879",
  "/landscapes/Canouan_DSC4611_6oeioFzSd_qHNwT3oBJL.webp",
  "/landscapes/Flat_Iron_Building_ZVltHZq8k.jpg?updatedAt=1722897535593",
  "/landscapes/con_DSC5622_yHevVlBjk.jpg?updatedAt=1722897216889",
  "/landscapes/beach-1662_RB7OnlWL9.jpg?updatedAt=1722897206968",
  "/landscapes/Canouan_DSC4867_5g60NB0rX.jpg?updatedAt=1722897204762",
  "/landscapes/IMG_0326_PBb6oOTP0t.JPG?updatedAt=1722897548003",
  "/landscapes/_DSC1725_hT6nO_jZe.webp",
  "/landscapes/_DSC17712_cfXmmwWLh_r_ErEEohh.webp",
  "/landscapes/DSC_1923_vRuR33r4l.webp",
];
const Landscapes = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isMounted, setIsMounted] = useState(false);
  const orderedImages = images;

  return (
    <div className="dark:bg-[#201c1c]">
      <Header />
      <ImgMasonry images={images} />
    </div>
  );
};

export default Landscapes;
